import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';
import UserDetailsForm from '../../components/forms/User/UserDetailsForm';

class UserSingleCreate extends React.Component {
  render() {
    const { onCreate } = this.props;
    return (
      <div>
        <Row>
          <Col>
            <Card className="mb-4">
              <Card.Header className={'card-header--crud'}>
                <div className="d-flex align-items-center">
                  <span className="crud__meta">
                    <Link to={ROUTES.USERS.ALL.replace('/:page', '')}>&larr; Back to User List</Link>
                  </span>
                </div>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col>
                    <h1 className="crud__body-title">Create a New User</h1>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    {/* CRUD Main Form - Start */}
                    <Row>
                      <Col>
                        <UserDetailsForm onCreate={onCreate} isCreate={true} />
                      </Col>
                    </Row>
                    {/* CRUD Main Form - END */}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default UserSingleCreate;
